/* Novelys NFC — depliage de la liste d'avis.

   POURQUOI DU JAVASCRIPT POUR UN SIMPLE DEPLIAGE.
   La version precedente etait une case a cocher masquee (`position:absolute;
   opacity:0`) plus le selecteur `:checked ~`. Cliquer le libellé donne
   forcement le focus a cette case — et **Chrome cessait alors de peindre toute
   la page**. Pas seulement les avis : plus rien n'etait dessine ni cliquable,
   alors que la mise en page restait juste (les cartes avaient bien leurs
   coordonnees). Ecran entierement blanc, signale par Amjad le 26 aout 2026 avec
   une capture.

   Isole a la ligne pres : cocher la case par script ne cassait rien, appeler
   `focus()` dessus cassait tout, et l'etat restait casse apres `blur()`. Remis
   en `position:static`, le focus ne posait plus de probleme. **Aucune commande
   de formulaire masquee et focalisable dans ce theme.**

   Sans JavaScript, les 53 avis s'affichent d'emblee et le bouton disparait
   (voir le <noscript> de la section) : on ne laisse jamais un visiteur devant
   un bouton mort. */
(function () {
  'use strict';

  function boot() {
    var boutons = document.querySelectorAll('[data-nv-plus]');
    for (var i = 0; i < boutons.length; i++) {
      brancher(boutons[i]);
    }
  }

  function brancher(btn) {
    if (btn.dataset.nvReady === '1') return;
    btn.dataset.nvReady = '1';

    var liste = document.getElementById(btn.getAttribute('aria-controls'));
    if (!liste) return;

    btn.addEventListener('click', function () {
      liste.classList.remove('is-coupe');
      btn.setAttribute('aria-expanded', 'true');

      var enveloppe = btn.parentElement;
      if (enveloppe) enveloppe.hidden = true;

      /* Le bouton vient de disparaitre : sans cela le focus retombe sur <body>
         et la tabulation repart du haut de la page. On le pose sur le premier
         avis revele, sans faire sauter le defilement. */
      var revele = liste.children[9];
      if (revele) {
        revele.setAttribute('tabindex', '-1');
        try { revele.focus({ preventScroll: true }); } catch (e) {}
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
